import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: François Risoud
 * id D81D0F0F-E856-4F7A-BB00-B4462105D5DB
 * name battery-arrow-up-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/battery-arrow-up-outline.svg
 * tags
 * - Battery 
 */
export const BatteryArrowUpOutlineIcon = createSvgIcon(<><path d="M13.54 22H7.33C6.6 22 6 21.4 6 20.67V5.33C6 4.6 6.6 4 7.33 4H9V2H15V4H16.67C17.4 4 18 4.6 18 5.33V12C17.3 12 16.63 12.13 16 12.35V6H8V20H12.35C12.61 20.75 13 21.42 13.54 22M20.94 17.5L17.94 14.5L14.94 17.5H16.94V21.5H18.94V17.5H20.94" /></>, 'BatteryArrowUpOutlineIcon');
export default BatteryArrowUpOutlineIcon